import gql from 'graphql-tag'

/**
 * *** WARNING ***
 * The following is still tinkered to the old API
 */

export const PITCH_FREELANCER_FRAGMENT = gql`
  fragment PitchFreelancerFragment on Freelancer {
    localId
    globalId
    name
    picture
    hasPicture
    initials
    primaryProfile {
      url
    }
    tags {
      globalId
      localId
      name
    }
  }
`

export const CANDIDATE_FRAGMENT = gql`
  fragment CandidateFragment on Candidate {
    localId
    globalId
    inviteEmail
    status
    currency
    hourRate
    dailyRate
    monthlyRate
    jobTitle
    links

    files {
      globalId
      localId
      name
    }

    createdAt
    freelancer {
      ...PitchFreelancerFragment
    }
  }
  ${PITCH_FREELANCER_FRAGMENT}
`

export const PITCHING_CANDIDATE_FRAGMENT = gql`
  fragment PitchingCandidateFragment on Candidate {
    ...CandidateFragment
    rate(rateType: $rateType, currency: $currency)
  }
  ${CANDIDATE_FRAGMENT}
`
